<template>
    <div class="zui-spinner-fading-line" :style="contaienrStyle">
        <div :style="style"></div>
        <div :style="style"></div>
        <div :style="style"></div>
        <div :style="style"></div>
        <div :style="style"></div>
        <div :style="style"></div>
        <div :style="style"></div>
        <div :style="style"></div>
        <div :style="style"></div>
        <div :style="style"></div>
        <div :style="style"></div>
        <div :style="style"></div>
    </div>
</template>

<script>
export default {
    name: "fadingLine",
    props: {
        backgroundColor: {
            type: String,
            default: "transparent"
        },
        color: {
            type: String,
            default: "#ccc"
        },
        size: {
            type: String,
            default: "100%"
        }
    },

    data() {
        let { color, backgroundColor, size } = this;
        let origin = this.caculOrigin(size);
        let style = {
            color: color,
            backgroundColor: backgroundColor,
            borderTopColor: color,
            borderLeftColor: color,
            borderBottomColor: color,
            transformOrigin: `${origin} ${origin}`
        };
        let contaienrStyle = {
            width: size,
            height: size
        };
        return {
            style,
            contaienrStyle
        };
    },
    methods: {
        caculOrigin(size) {
            let num = parseFloat(size);
            let halfNum = num / 2;
            return size.replace(num, halfNum);
        }
    }
};
</script>

<style scoped lang="scss">
// .zui-spinner-fading-line {
//     width: 100px;
//     height: 60px;
//     margin: 100px auto;
//     position: relative;
// }
.zui-spinner-fading-line {
    display: inline-block;
    position: relative;
}
.zui-spinner-fading-line div {
    animation: lds-spinner 1.2s linear infinite;
}
.zui-spinner-fading-line div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 0px;
    left: 50%;
    margin-left: -2px;
    width: 4px;
    height: 14px;
    border-radius: 20%;
    background: #fff;
}
.zui-spinner-fading-line div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
}
.zui-spinner-fading-line div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
}
.zui-spinner-fading-line div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
}
.zui-spinner-fading-line div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
}
.zui-spinner-fading-line div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
}
.zui-spinner-fading-line div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
}
.zui-spinner-fading-line div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
}
.zui-spinner-fading-line div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
}
.zui-spinner-fading-line div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
}
.zui-spinner-fading-line div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
}
.zui-spinner-fading-line div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
}
.zui-spinner-fading-line div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
}
@keyframes lds-spinner {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
</style>
